import * as EP from "./endpoints";
import HTTP from "@/packages/http";

export const AuthService = {
  login(formData) {
    return HTTP.post(EP.LOGIN, { ...formData }).then(({ data }) => data);
  },
  signUp(formData) {
    return HTTP.post(EP.SIGN_UP, { ...formData }).then(({ data }) => data);
  },
  forgotPassword(formData) {
    return HTTP.post(EP.FORGOT_PASSWORD, { ...formData }).then(({ data }) => data);
  },
  verifyToken(formData) {
    return HTTP.get(EP.VERIFY_TOKEN + formData.token).then(({ data }) => data);
  },
  resetPassword(formData) {
    return HTTP.post(EP.RESET_PASSWORD + formData.token, { ...formData }).then(({ data }) => data);
  }
};
